import PropTypes from "prop-types";

import FormDialog from "components/modals/FormDialog";
import VoicemailForm from "./VoicemailForm";

const VoicemailModal = ({ model, open, onOpenChange, onSuccess }) => (
  <FormDialog
    FormComponent={VoicemailForm}
    model={model}
    modelType="Voicemail"
    open={open}
    onOpenChange={onOpenChange}
    onSuccess={onSuccess}
  />
);

VoicemailModal.propTypes = {
  model: PropTypes.object,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default VoicemailModal;
